export default __webpack_public_path__ + "static/media/IFPI-white.c5d4983c.png";